import { SandboxTaskInput } from '../../store/domains/tasks';
import { SandboxOperationHandler } from '../types';
import { inputObject, page } from './utils';

const taskInput = (variables: Record<string, unknown>): SandboxTaskInput =>
  inputObject(variables);

const taskId = (variables: Record<string, unknown>): number => {
  const input = inputObject(variables);
  return Number(variables.id ?? input.id);
};

export const taskResolvers: Record<string, SandboxOperationHandler> = {
  tasks: (variables, store) => ({
    tasks: page(store.getState().tasks, variables),
  }),
  createWorkerTask: (variables, store) => ({
    createWorkerTask: store.createTask(taskInput(variables)),
  }),
  updateWorkerTask: (variables, store) => ({
    updateWorkerTask: store.updateTask(taskId(variables), taskInput(variables)),
  }),
  deleteWorkerTask: (variables, store) => ({
    deleteWorkerTask: store.deleteTask(taskId(variables)),
  }),
  setWorkerTaskComplete: (variables, store) => {
    const input = inputObject(variables);
    const value = variables.value ?? input.value;
    return {
      setWorkerTaskComplete: store.setTaskCompleted(
        taskId(variables),
        Boolean(value)
      ),
    };
  },
};
